import * as React from 'react';

import { cn, Col, ensureValue, Loading } from '@rematter/ui-web';
import { Chatbox } from '@talkjs/react';
import { useAtomValue } from 'jotai';
import Talk from 'talkjs';

import * as conversationListState from '../_state/conversationList.state';

export type TabMessagesProps = { visible: boolean };

export const TabMessages = ({ visible }: TabMessagesProps) => {
  const chatboxRef = React.useRef<Talk.Chatbox>(null);

  const selectedConversation = useAtomValue(
    conversationListState.$selectedConversation,
  );

  const syncConversation = React.useCallback(
    (session: Talk.Session) => {
      const conversation = session.getOrCreateConversation(
        ensureValue(selectedConversation?.id),
      );

      return conversation;
    },
    [selectedConversation?.id],
  );

  React.useEffect(() => {
    if (visible) {
      chatboxRef.current?.messageField.focus();
    }
  }, [visible]);

  return (
    <Chatbox
      chatboxRef={chatboxRef as never}
      className={cn(
        '@TabMessages h-full flex-1 overflow-clip rounded-[10px]',
        visible ? 'contents' : 'hidden',
      )}
      showChatHeader={false}
      syncConversation={syncConversation}
      loadingComponent={
        <Col
          xCenter
          yCenter
          className={
            'light size-full rounded-[10px] border border-neutral/20 bg-abs-white'
          }
        >
          <Loading isLoading />
        </Col>
      }
    />
  );
};
